<template>
    <Dialog
        v-model:visible="optionsDialog"
        class="w-full lg:w-1/3 mx-5"
        position="bottomright"
        id="optionsDialog"
        @hide="$emit('discardOptions')"
    >
        <template #header>
            <div class="font-medium text-gray-700 text-lg">
                Envio(s) seleccionado(s): {{ selectedShipping?.length }}
            </div>
        </template>

        <div class="py-2 flex flex-col space-y-2 align-end">
            <div
                class="flex flex-col lg:flex-row w-full space-y-2 lg:space-y-0"
            >
                <Button
                    class="w-full lg:w-1/2"
                    @click="openConfirmReadyToPickupDialog"
                >
                    <div class="flex items-center space-x-2">
                        <Icon size="15">
                            <Check />
                        </Icon>
                        <span>Listo(s) para recolectar</span>
                    </div>
                </Button>
                <Button
                    class="w-full lg:w-1/2"
                    :loading="exportLoading"
                    @click="handleExport"
                >
                    <div class="flex items-center space-x-2">
                        <Icon size="15">
                            <FileExcel />
                        </Icon>
                        <span> Exportar xls </span>
                    </div>
                </Button>
            </div>
            <div
                class="flex flex-col lg:flex-row w-full space-y-2 lg:space-y-0"
            >
                <Button class="w-full lg:w-1/2" @click="handleDownloadLabels">
                    <div class="flex items-center space-x-2">
                        <Icon size="15">
                            <Bookmark />
                        </Icon>
                        <span>Descargar Etiqueta(s) </span>
                    </div>
                </Button>
                <Button
                    class="w-full lg:w-1/2"
                    variant="destructive"
                    @click="openDeleteShippingDialog"
                >
                    <div class="flex items-center space-x-2">
                        <Icon size="15">
                            <Trash />
                        </Icon>
                        <span>Eliminar envio(s)</span>
                    </div>
                </Button>
            </div>
        </div>
    </Dialog>
    <Dialog
        v-model:visible="confirmReadyToPickupDialog"
        :style="{ margin: '0 10px', maxWidth: '400px' }"
        header="Confirmar"
        :modal="true"
    >
        <div class="flex items-center justify-center">
            <span>
                ¿Seguro que deseas marcar los envios seleccionados como listos
                para recolectar?
            </span>
        </div>
        <template #footer>
            <div class="flex justify-end space-x-2">
                <Button
                    variant="dismissive"
                    @click="confirmReadyToPickupDialog = false"
                >
                    Cancelar
                </Button>
                <Button :loading="confirmLoading" @click="handleReadyToPickup">
                    Confirmar
                </Button>
            </div>
        </template>
    </Dialog>
    <Dialog
        v-model:visible="confirmDeleteShippingDialog"
        :style="{ width: '450px' }"
        header="Confirmar eliminar"
        :modal="true"
    >
        <div class="flex items-center justify-center">
            <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
            />
            <span>
                ¿Seguro que deseas eliminar ({{ selectedShipping.length }})
                envio(s) seleccionado(s)?
            </span>
        </div>
        <template #footer>
            <div class="flex justify-end space-x-2">
                <Button
                    variant="dismissive"
                    @click="confirmDeleteShippingDialog = false"
                >
                    Cancelar
                </Button>
                <Button
                    :loading="confirmLoading"
                    variant="destructive"
                    @click="handleDeleteShipping"
                >
                    Eliminar
                </Button>
            </div>
        </template>
    </Dialog>
</template>

<script>
import axios from "axios";
import Button from "@/shared/Button.vue";
import { Icon } from "@vicons/utils";
import { FileExcel, Check, Bookmark, Trash } from "@vicons/fa";

export default {
    name: "ExportDialog",
    components: {
        Button,
        Icon,
        FileExcel,
        Check,
        Bookmark,
        Trash,
    },
    props: {
        optionsDialog: Boolean,
        selectedShipping: Array,
    },
    emits: ["deleteSuccess", "reloadProps", "discardOptions"],
    data() {
        return {
            confirmReadyToPickupDialog: false,
            confirmLoading: false,
            confirmDeleteShippingDialog: false,
        };
    },
    computed: {},
    methods: {
        openConfirmReadyToPickupDialog() {
            this.confirmReadyToPickupDialog = true;
        },
        openDeleteShippingDialog() {
            this.confirmDeleteShippingDialog = true;
        },
        handleReadyToPickup() {
            this.confirmLoading = true;
            let envios = this.selectedShipping.map((e) => e.seguimiento);
            axios
                .post("/envios/marcar-listo-recolectar", { envios })
                .then((res) => {
                    if (res.data.success) {
                        console.log(res.data);
                        this.confirmReadyToPickupDialog = false;
                        this.downloadManifest();
                        this.$emit("reloadProps");
                        this.$emit("discardOptions");
                    }
                    this.confirmLoading = false;
                })
                .catch((err) => {
                    console.error(err.message);
                    this.confirmLoading = false;
                });
        },
        handleDeleteShipping() {
            this.confirmLoading = true;
            let envios = this.selectedShipping.map((e) => e.seguimiento);
            axios
                .post("/envios/eliminar-multiples", { envios })
                .then((res) => {
                    if (res.data.success) {
                        console.log(res.data);
                        this.confirmDeleteShippingDialog = false;
                        this.$emit("deleteSuccess");
                    }
                    this.confirmLoading = false;
                })
                .catch((err) => {
                    console.error(err.message);
                    this.confirmLoading = false;
                });
        },
        handleExport() {
            this.exportLoading = true;
            let envios = this.selectedShipping.map((e) => e.seguimiento);
            axios
                .get("/envios/exportar-seleccionados", {
                    responseType: "blob",
                    params: { envios },
                })
                .then((res) => {
                    console.log(res);
                    let blob = new Blob([res.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    let downloadXls = document.createElement("a");
                    downloadXls.href = window.URL.createObjectURL(blob);
                    downloadXls.download = `listado_envios_${Date.now()}.xls`;
                    downloadXls.click();
                    this.exportLoading = false;
                    this.$emit("discardOptions");
                })
                .catch((err) => {
                    console.error(err);
                    this.$emit("dispatchNotification", {
                        severity: "error",
                        summary: "Ha ocurrido un error",
                        detail: "Intenta más tarde",
                        life: 3000,
                    });
                    this.exportLoading = false;
                });
        },
        handleDownloadLabels() {
            let envios = this.selectedShipping.map((e) => e.seguimiento);
            axios
                .get("/envios/multiples-etiquetas", { params: { envios } })
                .then((res) => {
                    if (res.data.success) {
                        let downloadLabel = document.createElement("a");
                        downloadLabel.href =
                            "data:application/octet-stream;base64," +
                            res.data.etiquetas.pdf;
                        downloadLabel.download = `shipro_etiquetas_${Date.now()}.pdf`;
                        downloadLabel.click();
                        this.$emit("discardOptions");
                        this.$emit("reloadProps");
                    } else if (!res.data.success) {
                        alert("Solo etiquetas de una misma sucursal!");
                        this.$emit("discardOptions");
                    }
                })
                .catch((err) => console.log(err.message));
        },
        downloadManifest() {
            let envios = this.selectedShipping.map((e) => e.seguimiento);
            axios
                .post("/envios/descargar-remito", {
                    envios,
                })
                .then((res) => {
                    let manifest = document.createElement("a");
                    manifest.href =
                        "data:application/octet-stream;base64," + res.data.pdf;
                    manifest.download = `shipro_remito_${Date.now()}.pdf`;
                    manifest.click();
                });
        },
    },
};
</script>

<style>
#optionsDialog .p-dialog-header {
    border-top: 1px solid #d4d4d8;
    border-right: 1px solid #d4d4d8;
    border-left: 1px solid #d4d4d8;
}
#optionsDialog .p-dialog-content {
    border-right: 1px solid #d4d4d8;
    border-left: 1px solid #d4d4d8;
    border-bottom: 1px solid #d4d4d8;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
</style>
